import { createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";

import rootSaga from "./root-saga";
import rootReducer from "./root-reducer";

const sagaMiddlware = createSagaMiddleware();

const middlewares = [sagaMiddlware];

if (process.env.NODE_ENV === "development") {
	middlewares.push(logger);
}

export const store = createStore(rootReducer, applyMiddleware(...middlewares));

sagaMiddlware.run(rootSaga);

export const persistor = persistStore(store);

export default { store, persistor };
